// Firebase is loaded lazily (dynamic import) so the SDK doesn't weigh down
// the initial page load — it's only fetched when a visitor submits the form.

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId
);

export interface ReservationInput {
  name: string;
  email: string;
  phone: string;
  date: string;
  time: string;
  service: string;
  passengers: string;
  pickup: string;
  destination: string;
  message: string;
}

export async function submitReservation(data: ReservationInput) {
  if (!isFirebaseConfigured) {
    throw new Error("Firebase is not configured. Set VITE_FIREBASE_* env vars.");
  }
  const [{ initializeApp, getApps }, firestore] = await Promise.all([
    import("firebase/app"),
    import("firebase/firestore"),
  ]);
  const app = getApps()[0] ?? initializeApp(firebaseConfig);
  const db = firestore.getFirestore(app);
  const ref = await firestore.addDoc(firestore.collection(db, "reservations"), {
    ...data,
    status: "new",
    createdAt: firestore.serverTimestamp(),
    source: "website",
  });
  return ref.id;
}
